import { render, staticRenderFns } from "./InfoDetailsWrapper.vue?vue&type=template&id=7c4367ac"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c4367ac')) {
      api.createRecord('7c4367ac', component.options)
    } else {
      api.reload('7c4367ac', component.options)
    }
    module.hot.accept("./InfoDetailsWrapper.vue?vue&type=template&id=7c4367ac", function () {
      api.rerender('7c4367ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inforationCards/InfoDetailsWrapper.vue"
export default component.exports